import ContinentCountriesCard from './ContinentCountriesCard';
export default ContinentCountriesCard;



// WEBPACK FOOTER //
// ./src/components/Continent/ContinentCountries/ContinentCountriesCard/index.js